import { useState } from 'react';

import axiosStuffedDetector from 'config/axiosDetectStuffedKeywords';

import { KeywordStuffingModalPrompts } from 'utils/Constants';

import {
  cleanWordListTotal,
  filterWordsCommon75,
  filterkeywordsStuffing,
  getPotentialKeywordStuffingVarients,
  getTheAddedText,
  replaceTextInColor,
} from 'utils/keywordStuffing/keywordStuffing';

export const useWriterKeywordStuffing = ({
  setSidebarCollapsed,
  handleScrollBottom,
  actualHtmlContent,
  setActualHtmlContent,
  textTitle,
  keywords,
  extractWords,
  textType,
  initialTextContent,
  actualTextContent,
  initialTextWordCount,
  actualTextWordCount,
  setStuffedKeywords,
  deliverText,
  t,
  orderType,
  setActualTextContent,
  setInitialHtmlContent,
}) => {
  const [showKeywordStuffingModal, setShowKeywordStuffingModal] =
    useState(false);
  const [keywordStuffingModalTitle, setKeywordStuffingModalTitle] =
    useState('');
  const [keywordStuffingModalMsg, setKeywordStuffingModalMsg] = useState('');
  const [keywordStuffingModalData, setKeywordStuffingModalData] = useState([]);
  const [keywordStuffingModalCloseBtn, setKeywordStuffingModalCloseBtn] =
    useState(true);
  const [initialStuffedKeywords, setInitialStuffedKeywords] = useState([]);

  const [keywordStuffingLoading, setKeywordStuffingLoading] = useState(false);

  const keywordStuffingCall = () => {
    // Show sidebar
    setSidebarCollapsed(false);

    // Scroll the sidebar to the bottom
    handleScrollBottom();

    setKeywordStuffingLoading(true);

    let reinitilazedActualHtmlContent = actualHtmlContent
      ? actualHtmlContent
      : actualTextContent;

    reinitilazedActualHtmlContent = reinitilazedActualHtmlContent.replace(
      new RegExp('style="color: red;"', 'g'),
      'style="color: black;"'
    );

    setActualHtmlContent(reinitilazedActualHtmlContent);
    const allKeywords = textTitle + ' ' + keywords;
    const wordsArray = extractWords(allKeywords);

    const actualTextContentValue =
      textType === 'NON_TRANSLATED' && initialTextContent
        ? getTheAddedText(initialTextContent, actualTextContent)
        : actualTextContent;

    const initialTextContentValue =
      (textType === 'NON_TRANSLATED') & initialTextContent
        ? initialTextContent
        : '';
    const possibleStuffedKeywords = [
      ...wordsArray,
      ...cleanWordListTotal(keywords),
    ];
    const initialTextWordCountValue =
      textType === 'NON_TRANSLATED' ? initialTextWordCount : 0;

    const postData = {
      actualTextContent: actualTextContentValue,
      initialTextContent: initialTextContentValue,
      possibleStuffedKeywords,
      initialTextWordCount: initialTextWordCountValue,
      actualTextWordCount,
    };

    axiosStuffedDetector
      .post(`/texts/keywordStuffing`, postData, {
        headers: {
          accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        const actualStuffedKeywordsList = filterWordsCommon75(
          filterkeywordsStuffing(response.data['actualStuffedKeywords'])
        );
        const initialStuffedKeywordsList = filterWordsCommon75(
          filterkeywordsStuffing(response.data['initialStuffedKeywords'])
        );
        setStuffedKeywords(actualStuffedKeywordsList);
        setInitialStuffedKeywords(initialStuffedKeywordsList);
        if (
          actualStuffedKeywordsList.length === 0 &&
          initialStuffedKeywordsList.length === 0
        ) {
          deliverText(reinitilazedActualHtmlContent);
        }
        if (
          actualStuffedKeywordsList.length === 0 &&
          initialStuffedKeywordsList.length > 0
        ) {
          setKeywordStuffingModalTitle(
            t(KeywordStuffingModalPrompts.initialTextKeywordStuffingTitle)
          );
          setKeywordStuffingModalMsg(
            t(KeywordStuffingModalPrompts.initialTextKeywordStuffingMSg)
          );
          setKeywordStuffingModalData(initialStuffedKeywordsList);
          setKeywordStuffingModalCloseBtn(false);
          setShowKeywordStuffingModal(true);
        }
        if (actualStuffedKeywordsList.length > 0) {
          setKeywordStuffingModalTitle(
            t(KeywordStuffingModalPrompts.actualTextKeywordStuffingTitle)
          );
          setKeywordStuffingModalMsg(
            t(KeywordStuffingModalPrompts.actualTextKeywordStuffingMsg)
          );
          setKeywordStuffingModalData(actualStuffedKeywordsList);
          setKeywordStuffingModalCloseBtn(true);
          setShowKeywordStuffingModal(true);
        }
        setKeywordStuffingLoading(false);
        if (actualStuffedKeywordsList.length > 0) {
          let stuffedActualHtmtlContent = reinitilazedActualHtmlContent;

          const newActualStuffedKeywordsList = actualStuffedKeywordsList.map(
            (actualStuffedKeyword) => actualStuffedKeyword['word']
          );

          if (orderType === 'PREMIUM') {
            setActualHtmlContent(
              replaceTextInColor(
                stuffedActualHtmtlContent,
                getPotentialKeywordStuffingVarients([
                  ...newActualStuffedKeywordsList,
                  ...response.data['actualTextMatchedResult'],
                ]),
                'red'
              )
            );
          } else {
            setActualTextContent(
              replaceTextInColor(
                stuffedActualHtmtlContent,
                getPotentialKeywordStuffingVarients([
                  ...newActualStuffedKeywordsList,
                  ...response.data['actualTextMatchedResult'],
                ]),
                'red'
              )
            );
          }
        }
        if (initialStuffedKeywordsList.length > 0) {
          const newInitialStuffedKeywordsList = initialStuffedKeywordsList.map(
            (initialStuffedKeyword) => initialStuffedKeyword['word']
          );
          setInitialHtmlContent(
            replaceTextInColor(
              getPotentialKeywordStuffingVarients([
                ...newInitialStuffedKeywordsList,
                ...response.data['initialTextMatchedResult'],
              ]),
              'purple'
            )
          );
        }
      })
      .catch((error) => {
        // Handle errors here
        setKeywordStuffingLoading(false);
        console.error(error);
      });
  };

  return {
    keywordStuffingLoading,
    initialStuffedKeywords,
    showKeywordStuffingModal,
    keywordStuffingModalTitle,
    keywordStuffingModalMsg,
    keywordStuffingModalData,
    keywordStuffingModalCloseBtn,
    keywordStuffingCall,
    setShowKeywordStuffingModal,
    setInitialStuffedKeywords,
    setKeywordStuffingLoading,
  };
};
